<template lang="pug">
  .create-cv-reminder(v-if="show")
    .reminder-container
      .text {{ gettext('You don\'t have CVs, create it to employers find you!') }}
      .icon
        .mdi.mdi-close(@click="close()")
</template>

<script>
import { gettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'

const CONSTANTS = require('@/constants.json')

export default {
  name: 'createCvReminder',
  data () {
    return {
      CONSTANTS: CONSTANTS,
      hasCVs: false,
      closed: false,
      loaded: false
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions(['jobseekerGetCvs']),
    close () {
      window.localStorage.setItem('createCvReminder', true)
      this.closed = true
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    show () {
      if (
        this.getUser.profile_type !== this.CONSTANTS.JOBSEEKER_PROFILE_TYPE ||
        this.hasCVs ||
        this.closed ||
        !this.loaded
      ) {
        return false
      }
      return true
    }
  },
  watch: {
    '$route': function () {
      if (!this.closed && window.localStorage.getItem('createCvReminder')) {
        this.closed = true
      }
      if (this.getUser.profile_type === this.CONSTANTS.JOBSEEKER_PROFILE_TYPE && !this.loaded) {
        this.jobseekerGetCvs({page: 1, size: 10}).then(res => {
          this.loaded = true
          if (res.items.length) {
            this.hasCVs = true
          }
        })
      }
    }
  },
  created () {
    if (window.localStorage.getItem('createCvReminder')) {
      this.closed = true
    }
    if (this.getUser.profile_type !== this.CONSTANTS.JOBSEEKER_PROFILE_TYPE) return
    this.jobseekerGetCvs({page: 1, size: 10}).then(res => {
      this.loaded = true
      if (res.items.length) {
        this.hasCVs = true
      }
    })
  }
}
</script>

<style lang="scss">
.create-cv-reminder{
  width: 100%;
  padding: 1rem;
  font-size: 22px;
  background-color: #f4f4f4;
  .reminder-container{
    max-width: 1260px;
    width: 100%;
    display: flex;
    margin: 0 auto;
    align-content: center;
    align-items: center;
    justify-content: space-between;
  }
  .icon{
    font-size: 20px;
    cursor: pointer;
  }
}
@media screen and (max-width: 1086px){
  .create-cv-reminder{
    padding: 1rem 2rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 10000;
  }
}
@media screen and (max-width: 760px){
  .create-cv-reminder{
    font-size: 18px;
  }
}
@media screen and (max-width: 480px){
  .create-cv-reminder{
    padding: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/create-cv-reminder/index.vue